import React from 'react';
import styled from 'styled-components';
import Loader from '../../Loader';
import Box from '../Box';
import Text from '../Text';

export const CardTitle = ({
  children,
  noMargin,
  fontWeight = 'bold',
  ...props
}) => (
  <Box mb={noMargin ? 0 : 20}>
    <Text size="small" fontWeight={fontWeight} uppercase {...props}>
      {children}
    </Text>
  </Box>
);

export const CardDesc = ({ children, ...props }) => (
  <Box my={10}>
    <Text size="small" {...props}>
      {children}
    </Text>
  </Box>
);

export const CardLoading = ({ height, ...props }) => (
  <Card
    style={{ height: height || 350 }}
    align="center"
    justify="center"
    {...props}
  >
    <Loader />
  </Card>
);

const Card = styled(Box).attrs(props => ({
  p: 15,
  bg: props.bg || 'rgba 250 250 250',
  position: 'relative',
}))`
  overflow-x: ${p => p.overflow || 'unset'};
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.07);
`;

export default Card;
